export default __webpack_public_path__ + "static/media/blog-36-img1.4a7c2880.jpg";